import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable,forkJoin } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationTypeMasterService {

  private apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  NotiTypeMastSave(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/NotificationTypeMaster/NotiTypeMastSave',postData);
  }

  NotiTypeMastFill(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/NotificationTypeMaster/NotiTypeMastFill',postData);
  }

  NotiTypeMastDelete(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/admin/NotificationTypeMaster/NotiTypeMastDelete',postData);
  }
}
